import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'box-number',
    templateUrl: './box-number.component.html',
    styleUrls: ['./box-number.component.scss'],
    standalone: false
})
export class BoxNumberComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
